import React, { Suspense } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import LoadingComponent from "./components/LoadingComponent";
import Navbar from "./layouts/Navbar";
import ContentRoutes from "./routes/ContentRoutes";
import { typography, palette } from "./styles/config";
import "./styles/index.scss";

const theme = createTheme({
  typography: typography,
  palette: palette,
});

const _loading = <LoadingComponent />;

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div id="appContainer" className="defaultContainer">
        <Suspense fallback={_loading}>
          <Navbar />
          <ContentRoutes />
        </Suspense>
      </div>
    </ThemeProvider>
  );
}

export default App;
